import adminCards from 'utils/adminCards.ts';
import { CognitoUser } from 'schemas/UserInfo.schema.ts';

export function getWriteRoles(roles: string[]): string[] {
  return roles.filter((role: string) => role.endsWith(':write'));
}

export function getAdminRoles(roles: string[]): string[] {
  return roles.filter((role: string) => adminCards.some(({ requiredRole }) => role.endsWith(requiredRole)));
}

export function getTeamIdFromRole(role: string): string {
  const idx = role.lastIndexOf(':');
  return idx === -1 ? role : role.slice(0, idx);
}

export function getUserDisplayName(user: CognitoUser): string {
  if (user.given_name && user.family_name) {
    return `${user.given_name} ${user.family_name}`;
  }

  return user.email;
}
